<template>
    <transition name="slide-fade" >
        <div  id="academicsHolder" >
            <div class="uk-child-width-1-1" uk-grid>
                <!--<div class=" uk-background-secondary uk-light" style="padding: 20px; color: rgb(197,179,88) !important;">
                    <div class="uk-container uk-container-small ">
                        <p class="uk-text-center uk-text-lead@l uk-text-large@l">
                            Yes you, we want you in our family let us help get you comfortable.
                        </p>
                    </div>
                </div>-->

                <div >
                    <div class="uk-container uk-container-small">
                        <iframe src="https://give.ncu.edu.jm/donate/" height="1500" width="960" frameborder="0" style="border:none;overflow:hidden; max-width: 100%"></iframe>
                    </div>
                </div>




            </div>
        </div>
    </transition>
</template>

<script>
    export default {
        name: "donate",
        mounted(){
            window.scrollTo(0, 0);
        },
        metaInfo: {
            // Children can override the title.
            title: 'NCU Donations Page',
            // Result: My Page Title ← My Site
            // If a child changes the title to "My Other Page Title",
            // it will become: My Other Page Title ← My Site
            //titleTemplate: '%s ← My Site',
            // Define meta tags here.
            meta: [
                {'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8'},
                {name: 'viewport', content: 'width=device-width, initial-scale=1'},
                {name: 'description', content: 'The Rescue 2020 drive donation page at Northern Caribbean University '}
            ]
        }
    }
</script>

<style scoped>

</style>
